import { BrandKit } from "@redotech/redo-model/brand-kit";
import { SignupForm as ISignupForm } from "@redotech/redo-model/signup-form-schema";
import { memo } from "react";
import { BaseSignupForm } from "./base-signup-form";
import { SignupFormContainer } from "./signup-form-container";

export const SignupForm = memo(function SignupFormModal({
  form,
  brandKit,
  currentStep,
  onSubmitStep,
  onClose,
}: {
  form: ISignupForm;
  brandKit: BrandKit;
  currentStep: number;
  onSubmitStep: (
    stepIndex: number,
    formData: Record<string, string>,
  ) => Promise<void>;
  onClose?: () => void;
}) {
  return (
    <SignupFormContainer form={form} onClose={onClose} previewMobile={false}>
      <BaseSignupForm
        brandKit={brandKit}
        currentStep={currentStep}
        form={form}
        onClose={onClose}
        onSubmitStep={onSubmitStep}
      />
    </SignupFormContainer>
  );
});
